export default "__VITE_ASSET__DyU_lI6K__"